import type {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import type {CurrentUser} from 'common/report/queries/app-api/user-metadata-client';
import type {StorageManager} from 'common/contexts/storage-manager/types';
import type {SupportInfo} from 'common/report/queries/app-api/support-info-client';
import {UrlLocation} from 'iron/routes/global-sidenav/types';
import {TogglePanelSource} from 'common/components/resizable-panel/types';

export enum SectionKey {
  Data = `data`,
}

export type State = {
  showSendbirdWidget: boolean;
  isInviteUserModalOpen: boolean;
  closeInviteModalCallback: (() => void) | undefined;
};

export enum ExpansionMode {
  AlwaysExpanded = `always-expanded`,
  AlwaysCollapsed = `always-collapsed`,
  Auto = `auto`,
}

export enum ExpansionTrigger {
  KeyboardShortcut = `keyboard-shortcut`,
  FooterButton = `footer-button`,
  CollapsedEmptyArea = `collapsed-empty-area`,
  SparkReportOpened = `spark-report-opened`,
}

export type ExpansionSource = ExpansionTrigger | TogglePanelSource;

export type PersistedState = {
  expansionMode?: ExpansionMode;
  isSparkOpen?: boolean;
  expandedSections?: Partial<Record<SectionKey, boolean>>;
};

export type Props = {
  currentProject: CurrentProject | undefined;
  currentUser: CurrentUser | undefined;
  localStorageManager: StorageManager;
  location: UrlLocation;
  supportInfo: SupportInfo | null | undefined;
};
